import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetInventoryAPiService from './AssetInventoryAPiService';
import { GET_ALL_SCANS, GET_SCANS_EXCEL_EXPORT_FILE, SAVE_SCAN, UPDATE_SCAN, DOWNLOAD_TEMPLATE, UPLOAD_ASSETS } from 'Store/AssetInventory/MandAScan/MandAScanTypes';
import { isScanSaved, setAllScans, setScansExcelExportFile, setTemplateData, isAssetsUploaded } from 'Store/AssetInventory/MandAScan/MandAScanAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';


function* saveScan(req: any): any {
    try {
        yield put(globalLoaderText(req?.type == SAVE_SCAN ? "Saving Scan...." : "Updating Scan...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : req?.type == SAVE_SCAN ? `auditoperation/ma/scan` : `auditoperation/ma/update/scan`,
            apiMethod :  apiMethod.POST,
            payload : req.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(isScanSaved(response))
        } else {
            yield put(isScanSaved({status: false, message: "Error saving Scan, Please try again"}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(isScanSaved({status: false, message: "Error saving Scan, Please try again"}))
    }
}

function* getScansExcelExportFile(req: any): any {
    try {
        yield put(globalLoaderText("Downloading Scans...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `auditoperation/ma/gridexcel`,
            apiMethod :  apiMethod.POST,
            payload : req?.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setScansExcelExportFile(response))
        } 
    } catch (error) {
        console.log(error);
        yield put(setScansExcelExportFile(''))
        yield put(globalLoaderText(""));
    }
}
function* getAllScans(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Scans...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `auditoperation/ma/grid`,
            apiMethod :  apiMethod.POST,
            payload : req?.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAllScans(response))
        } else {
            yield put(setAllScans({}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(setAllScans({}))
        yield put(globalLoaderText(""));
    }
}

function* downloadTemplate(req: any): any {
    try {
        yield put(globalLoaderText("Downloading Template...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assetupload/download/template`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setTemplateData(response))
        } 
    } catch (error) {
        console.log(error);
        yield put(setTemplateData(''))
        yield put(globalLoaderText(""));
    }
}

function* uploadAssets(req: any): any {
    try {
        yield put(globalLoaderText("Uploading Assets...."));
        let payload = req.payload;

        payload.append("apiMethod", apiMethod.POST)
        payload.append("apiType", apiType.AssetManagement)
        payload.append("endpoint", `assetupload/upload`) 
        
        const response = yield call(
            AssetInventoryAPiService.post,
            `${API_URL.PostWebApp}/upload/attachments`, payload
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(isAssetsUploaded({status: true, message: "Uploaded Sucessfully.  Please check the M&A Dashboard for Upload Status"}))
        } else {
            yield put(isAssetsUploaded({status: false, message: "The Upload has failed.  Please Try Again"}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(isAssetsUploaded({status: false, message: "The Upload has failed.  Please Try Again"}))
    }
}

function* watchMergerAndAquisition() {
    yield takeEvery(SAVE_SCAN, saveScan)
    yield takeEvery(UPDATE_SCAN, saveScan)
    yield takeEvery(GET_ALL_SCANS, getAllScans)
    yield takeEvery(GET_SCANS_EXCEL_EXPORT_FILE, getScansExcelExportFile)
    yield takeEvery(DOWNLOAD_TEMPLATE, downloadTemplate)
    yield takeEvery(UPLOAD_ASSETS, uploadAssets)
}

export default function* combinedSaga() {
    yield all([
        watchMergerAndAquisition()
    ])
}